import { render, staticRenderFns } from "./Upgrade.vue?vue&type=template&id=c6e0426e&scoped=true&"
import script from "./Upgrade.vue?vue&type=script&lang=js&"
export * from "./Upgrade.vue?vue&type=script&lang=js&"
import style0 from "./Upgrade.vue?vue&type=style&index=0&id=c6e0426e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e0426e",
  null
  
)

export default component.exports